import { Redirect } from 'react-router-dom';

import PageLoadingSpinner from '../components/ehr/PageLoadingSpinner';
import {
  RIDER_APP_NEW_LOG_IN,
  usePublicFeatureFlags,
} from '../hooks/usePublicFeatureFlags';

// Account creation pages are hidden behind rider_app_new_log_in: the
// "Create new" link is removed, so send anyone who types the URL to sign in.
export function RequireAccountCreation({
  children,
}: {
  children: JSX.Element;
}) {
  // Revalidate: the visitor may have opened sign in before the flag was turned
  // on. Flags already known render the page at once; if the fresh answer says
  // the flag is on, the redirect below follows.
  const featureFlags = usePublicFeatureFlags({ revalidate: true });

  // Nothing known yet (e.g. the URL was typed): show it's loading.
  if (!featureFlags) return <PageLoadingSpinner />;

  if (featureFlags.includes(RIDER_APP_NEW_LOG_IN)) {
    return <Redirect to={{ pathname: '/login' }} />;
  }

  return children;
}
